import { useSyncExternalStore } from 'react';

/** The glass storefront switches to its desktop grid at 800 (PackLayout). */
const DESKTOP_QUERY = '(min-width: 800px)';

function canQuery(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function';
}

function subscribe(onChange: () => void): () => void {
  if (!canQuery()) return () => {};
  const query = window.matchMedia(DESKTOP_QUERY);
  query.addEventListener('change', onChange);
  return () => query.removeEventListener('change', onChange);
}

function isDesktop(): boolean {
  return canQuery() && window.matchMedia(DESKTOP_QUERY).matches;
}

/** True on the glass desktop layout; follows resizes. Sheets open as a
 *  centred dialog there and slide up from the bottom on a phone. */
export function useIsDesktopViewport(): boolean {
  return useSyncExternalStore(subscribe, isDesktop, () => false);
}
